import { Button, Modal } from "@mantine/core";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, confirmText }) => {
  const { t } = useTranslation();
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      centered
      classNames={{
        root: "dark:!bg-slate-700 !bg-gray-200",
        header: "dark:!bg-slate-700 !bg-gray-200",
        content: "!rounded-xl dark:!bg-slate-700 !bg-gray-200",
        title: "!text-md !font-semibold ",
        close: "dark:!text-white dark:!bg-gray-800 dark:hover:!bg-gray-800/70",
      }}
      title={title || t("actions.confirm")}
      overlayProps={{
        backgroundOpacity: 0.45,
        blur: 2,
        color: "#1E44FF",
      }}
    >
      <span className="font-normal">{confirmText}</span>

      <div className="flex w-full justify-end mt-2">
        <Button variant="filled" color="red" onClick={onConfirm}>
          {t("actions.confirm")}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
